import { create } from 'zustand';

interface ManageDigestReportModalState {
  slug: string;
  isOpen: boolean;
  onManageDigestReportModalClose: () => void;
  onManageDigestReportModalOpen: (slug: string) => void;
}

export const useManageDigestReportModalStore = create<ManageDigestReportModalState>(set => ({
  isOpen: false,
  slug: '',
  onManageDigestReportModalClose: () => set({ isOpen: false, slug: '' }),
  onManageDigestReportModalOpen: (slug: string) => set({ isOpen: true, slug }),
}));
